var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('ElRow',[_c('Header'),_c('ElRow',{attrs:{"clas":"section","type":"flex","justify":"center"}},[_c('RouterView')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }